<template>
    <div class="d-flex justify-content-center flex-wrap">
        <div class="col-12 col-md-8 col-lg-6">
            <div class="mb-4">
                <h1 class="fw-bold">
                    {{ $t('Auth.ForgotPassword.forgot_password') }}
                </h1>
            </div>
            <form @submit.prevent="forgotPassword" class="bg-white p-4">
                <div class="form-field mb-5">
                    <div class="field-wrapper">
                        <input type="text" ref="email" id="email" :class="{'text-danger' : errors.email}" required>
                        <label for="email" :class="{'text-danger' : errors.email}">
                            {{ $t('Auth.ForgotPassword.email') }}
                            <small class="text-danger" v-if="errors.email">
                                <span class="mx-2">
                                    -
                                </span>
                                {{ errors.email }}
                            </small>
                        </label>
                    </div>
                </div>
                <div class="d-flex justify-content-between align-items-center flex-wrap text-end">
                    <router-link to="/" class="text-first text-decoration-underline">
                        {{ $t('Auth.ForgotPassword.go_back') }}
                    </router-link>
                    <button type="submit" class="btn btn-lg btn-auth btn-auth-first">
                        {{ $t('Auth.ForgotPassword.send') }}
                    </button>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
export default {
    name: 'ForgotPassword',
    computed: {
        ...mapGetters(['apiPath', 'omsApiKey'])
    },
    data() {
        return {
            errors: {}
        }
    },
    methods: {
        ...mapMutations(['setErrorFromServer']),
        forgotPassword() {
            this.$http
                .post(`${this.apiPath}/email/send_forgot_password_request`, { email: this.$refs.email.value }, {
                    headers: {
                        'x-api-key': this.omsApiKey
                    }
                }).then((res) => {
                    if (res.data.errors) {
                        var errors = res.data.errors
                        for (var i = 0; i < errors.length; i++) {
                            var error = errors[i]
                            if (error.path == 'email') {
                                this.errors.email = this.$t(`Auth.ForgotPassword.errors.email.${error.msg}`)
                            }
                        }
                        this.$toast.error(this.$t('toast.fields_errors'))
                        return
                    }
                    if (res.data.data) {
                        this.$toast.success(`${this.$t('toast.sent_email')} <strong>${res.data.data.to}</strong>`)
                        this.$router.replace('/')
                        return
                    } 
                    switch (res.data) {
                        case 'No Account Found':
                            this.errors.email = this.$t('Auth.ForgotPassword.errors.email.NoAccountFound')
                            this.$toast.error(this.$t('Auth.ForgotPassword.errors.email.NoAccountFound'))
                            break
                        case 'Unconfirmed Email':
                            this.errors.email = this.$t('Auth.ForgotPassword.errors.email.UnconfirmedEmail')
                            this.$toast.info(this.$t('Auth.ForgotPassword.errors.email.UnconfirmedEmail'))
                            break
                    }
                })
                .catch((err) => {
                    this.setErrorFromServer(err.message)
                })
        }
    }
}
</script>